import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ImageCropperModule } from "ngx-img-cropper";
import { GoogleMapsModule } from '@angular/google-maps'
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { UppBaseModule } from '@unpispas/upp-base';

import { DataIdDirective } from '../directives/upp-dataid';
import { TouchDirective } from '../directives/upp-touch';
import { VisibleDirective } from '../directives/upp-visible';

import { ViewRenderer } from '../injectables/renderer';

import { UppApplicationComponent } from '../components/upp-application/upp-application';
import { UppApplicationMenuComponent } from '../components/upp-application/menu/upp-menu';
import { UppApplicationMainComponent } from '../components/upp-application/main/upp-main';
import { UppApplicationPageComponent } from '../components/upp-application/page/upp-page';

import { UppVisibleControlComponent } from '../components/upp-visible/upp-visible';

import { UppPanelComponent } from '../components/upp-panel/upp-panel';
import { UppPanelHeaderComponent } from '../components/upp-panel/header/upp-header';
import { UppPanelContentComponent } from '../components/upp-panel/content/upp-content';
import { UppPanelFooterComponent } from '../components/upp-panel/footer/upp-footer';

import { UppHeaderComponent } from '../components/upp-header/upp-header';
import { UppHeaderTitleComponent } from '../components/upp-header/upp-header';
import { UppHeaderButtonComponent }  from '../components/upp-header/upp-header';
import { UppHeaderContentComponent } from '../components/upp-header/upp-header';

import { UppSideMenuComponent } from '../components/upp-side-menu/upp-side-menu';
import { UppSideMenuHeaderComponent } from '../components/upp-side-menu/upp-side-menu';
import { UppSideMenuHeaderToggleComponent } from '../components/upp-side-menu/upp-side-menu';
import { UppSideMenuContentComponent } from '../components/upp-side-menu/upp-side-menu';
import { UppSideMenuSectionComponent } from '../components/upp-side-menu/upp-side-menu';
import { UppSideMenuActionComponent } from '../components/upp-side-menu/upp-side-menu';

import { UppDropdownComponent } from '../components/upp-dropdown/upp-dropdown';
import { UppDropdownTitleComponent } from '../components/upp-dropdown/upp-dropdown';
import { UppDropdownSplitComponent } from '../components/upp-dropdown/upp-dropdown';
import { UppDropdownContentComponent } from '../components/upp-dropdown/upp-dropdown';
import { UppButtonBarComponent } from '../components/upp-button-bar/upp-button-bar';
import { UppButtonBarItemComponent } from '../components/upp-button-bar/upp-button-bar';
import { UppDateComponent } from '../components/upp-date/upp-date';
import { UppDateModalComponent } from '../components/upp-date/upp-date';
import { UppTimeComponent } from '../components/upp-time/upp-time';
import { UppTimeModalComponent } from '../components/upp-time/upp-time';

import { UppScrollableComponent } from '../components/upp-scrollable/upp-scrollable';

import { ViewModeDirective } from '../components/upp-grid/upp-grid';
import { UppGridComponent } from '../components/upp-grid/upp-grid';
import { UppGridItemComponent } from '../components/upp-grid/upp-grid';
import { UppGridEmptyComponent } from '../components/upp-grid/upp-grid';

import { UppCropComponent } from '../components/upp-crop/upp-crop';
import { UppColorComponent } from '../components/upp-color/upp-color';
import { UppBarcodeDisplayComponent } from '../components/upp-barcode/display/upp-display';
import { UppBarcodeScanningComponent } from '../components/upp-barcode/scanning/upp-scanning';
import { UppScaleInputComponent } from '../components/upp-scale/upp-input';
import { UppModalCropComponent } from '../components/upp-image/upp-image';
import { UppImageComponent } from '../components/upp-image/upp-image';

import { UppThumbComponent } from '../components/upp-thumb/upp-thumb';
import { UppThumbTopLeftComponent } from '../components/upp-thumb/upp-thumb';
import { UppThumbTopRightComponent } from '../components/upp-thumb/upp-thumb';
import { UppThumbBottomComponent } from '../components/upp-thumb/upp-thumb';

import { UppKbInputComponent } from '../components/upp-input/upp-input';
import { UppErInputComponent } from '../components/upp-input/upp-input';
import { UppInputComponent } from '../components/upp-input/upp-input';
import { UppInputSelectComponent } from '../components/upp-input-select/upp-input-select';
import { UppErTextAreaComponent } from '../components/upp-textarea/upp-textarea';
import { UppKbTextAreaComponent } from '../components/upp-textarea/upp-textarea';
import { UppTextAreaComponent } from '../components/upp-textarea/upp-textarea';
import { UppMdAddressComponent } from '../components/upp-address/upp-address';
import { UppErAddressComponent } from '../components/upp-address/upp-address';
import { UppAddressComponent } from '../components/upp-address/upp-address';
import { UppSearchComponent } from '../components/upp-search/upp-search';

import { UppSelectComponent } from '../components/upp-select/upp-select';
import { UppSelectItemComponent } from '../components/upp-select/upp-select';
import { UppSelectListComponent } from '../components/upp-select/upp-select';
import { UppSelectOptionComponent } from '../components/upp-select/upp-select';
import { UppLanguageSelectComponent } from '../components/upp-language/select/upp-select';
import { UppKbLanguageInputComponent } from '../components/upp-language/input/upp-input';
import { UppLanguageInputComponent } from '../components/upp-language/input/upp-input';
import { UppKbLanguageTextAreaComponent } from '../components/upp-language/area/upp-textarea';
import { UppLanguageTextAreaComponent } from '../components/upp-language/area/upp-textarea';

import { UppTabBarComponent } from '../components/upp-tabbar/upp-tabbar';
import { UppTabButtonComponent } from '../components/upp-tabbar/upp-tabbar';

import { UppFormComponent } from '../components/upp-form/upp-form';
import { UppFormImageComponent } from '../components/upp-form/upp-form';
import { UppFormSectionComponent } from '../components/upp-form/upp-form';
import { UppFormSectionEndComponent } from '../components/upp-form/upp-form';
import { UppFormActionComponent } from '../components/upp-form/upp-form';
import { UppFormWarningComponent } from '../components/upp-form/upp-form';
import { UppFormButtonBarComponent } from '../components/upp-form/upp-form';
import { UppFormBarButtonComponent } from '../components/upp-form/upp-form';
import { UppFormButtonsComponent } from '../components/upp-form/upp-form';
import { UppChartComponent } from '../components/upp-chart/upp-chart';
import { UppIconComponent } from '../components/upp-icon/upp-icon';
import { UppNumpadComponent } from '../components/upp-numpad/upp-numpad';
import { UppOverlayComponent } from '../components/upp-overlay/upp-overlay';
import { UppDialogComponent } from '../components/upp-dialog/upp-dialog';
import { UppDialogHeaderComponent } from '../components/upp-dialog/upp-dialog';
import { UppDialogContentComponent } from '../components/upp-dialog/upp-dialog';
import { UppDialogFooterComponent } from '../components/upp-dialog/upp-dialog';
import { UppOfflineComponent } from '../components/upp-offline/upp-offline';

@NgModule({
    declarations: [
        DataIdDirective,
        TouchDirective,
        VisibleDirective,
        ViewModeDirective,

        UppApplicationComponent,
        UppApplicationMenuComponent,
        UppApplicationMainComponent,
        UppApplicationPageComponent,

        UppVisibleControlComponent,

        UppPanelComponent,
        UppPanelHeaderComponent,
        UppPanelContentComponent,
        UppPanelFooterComponent,

        UppHeaderComponent,
        UppHeaderTitleComponent,
        UppHeaderButtonComponent,
        UppHeaderContentComponent,

        UppSideMenuComponent,
        UppSideMenuHeaderComponent,
        UppSideMenuHeaderToggleComponent,
        UppSideMenuContentComponent,
        UppSideMenuSectionComponent,
        UppSideMenuActionComponent,

        UppDropdownComponent,
        UppDropdownTitleComponent,
        UppDropdownSplitComponent,
        UppDropdownContentComponent,
        UppButtonBarComponent,
        UppButtonBarItemComponent,
        UppDateComponent,
        UppDateModalComponent,
        UppTimeComponent,
        UppTimeModalComponent,

        UppScrollableComponent,

        UppGridComponent,
        UppGridItemComponent,
        UppGridEmptyComponent,

        UppCropComponent,
        UppColorComponent,
        UppBarcodeDisplayComponent,
        UppBarcodeScanningComponent,
        UppScaleInputComponent,
        UppModalCropComponent,
        UppImageComponent,

        UppThumbComponent,
        UppThumbTopLeftComponent,
        UppThumbTopRightComponent,
        UppThumbBottomComponent,

        UppKbInputComponent,
        UppErInputComponent,
        UppInputComponent,
        UppInputSelectComponent,
        UppKbTextAreaComponent,
        UppErTextAreaComponent,
        UppTextAreaComponent,
        UppMdAddressComponent,
        UppErAddressComponent,
        UppAddressComponent,
        UppSearchComponent,

        UppSelectComponent,
        UppSelectItemComponent,
        UppSelectListComponent,
        UppSelectOptionComponent,
        UppLanguageSelectComponent,
        UppKbLanguageInputComponent,
        UppLanguageInputComponent,
        UppKbLanguageTextAreaComponent,
        UppLanguageTextAreaComponent,

        UppTabBarComponent,
        UppTabButtonComponent,

        UppFormComponent,
        UppFormImageComponent,
        UppFormSectionComponent,
        UppFormSectionEndComponent,
        UppFormActionComponent,
        UppFormWarningComponent,
        UppFormButtonBarComponent,
        UppFormBarButtonComponent,
        UppFormButtonsComponent,
        UppChartComponent,
        UppIconComponent,
        UppNumpadComponent,
        UppOverlayComponent,
        UppDialogComponent,
        UppDialogHeaderComponent,
        UppDialogContentComponent,
        UppDialogFooterComponent,
        UppOfflineComponent
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        ImageCropperModule,
        GoogleMapsModule,
        MatDatepickerModule,
        MatNativeDateModule,
        UppBaseModule
    ],
    exports: [
        ReactiveFormsModule,

        DataIdDirective,
        TouchDirective,

        UppApplicationComponent,
        UppApplicationMenuComponent,
        UppApplicationMainComponent,
        UppApplicationPageComponent,

        UppVisibleControlComponent,
        
        UppPanelComponent,
        UppPanelHeaderComponent,
        UppPanelContentComponent,
        UppPanelFooterComponent,

        UppHeaderComponent,
        UppHeaderTitleComponent,
        UppHeaderButtonComponent,
        UppHeaderContentComponent,
        
        UppSideMenuComponent,
        UppSideMenuHeaderComponent,
        UppSideMenuHeaderToggleComponent,
        UppSideMenuContentComponent,
        UppSideMenuSectionComponent,
        UppSideMenuActionComponent,

        UppDropdownComponent,
        UppDropdownTitleComponent,
        UppDropdownSplitComponent,
        UppDropdownContentComponent,
        UppButtonBarComponent,
        UppButtonBarItemComponent,
        UppDateComponent,
        UppTimeComponent,

        UppScrollableComponent,

        UppGridComponent,
        UppGridItemComponent,
        UppGridEmptyComponent,

        UppColorComponent,
        UppBarcodeDisplayComponent,
        UppBarcodeScanningComponent,
        UppScaleInputComponent,
        UppImageComponent,
        
        UppThumbComponent,
        UppThumbTopLeftComponent,
        UppThumbTopRightComponent,
        UppThumbBottomComponent,

        UppKbInputComponent,
        UppKbTextAreaComponent,
        UppInputComponent,
        UppInputSelectComponent,
        UppTextAreaComponent,
        UppAddressComponent,
        UppSearchComponent,

        UppSelectComponent,
        UppSelectItemComponent,
        UppSelectListComponent,
        UppSelectOptionComponent,
        UppLanguageSelectComponent,
        UppKbLanguageInputComponent,
        UppLanguageInputComponent,
        UppKbLanguageTextAreaComponent,
        UppLanguageTextAreaComponent,

        UppTabBarComponent,
        UppTabButtonComponent,

        UppFormComponent,
        UppFormImageComponent,
        UppFormSectionComponent,
        UppFormSectionEndComponent,
        UppFormActionComponent,
        UppFormWarningComponent,
        UppFormButtonBarComponent,
        UppFormBarButtonComponent,        
        UppFormButtonsComponent,
        UppChartComponent,
        UppIconComponent,
        UppNumpadComponent,
        UppOverlayComponent,
        UppDialogComponent,
        UppDialogHeaderComponent,
        UppDialogContentComponent,
        UppDialogFooterComponent,
        UppOfflineComponent
    ],
    providers: [
        ViewRenderer
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class UppWdgtModule {}